import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Paper, Grid, Collapse, IconButton } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import DateHeadings from './DateHeadings';
import EmployeeChip from './EmployeeChip';
import {
  generateDaysOfWeekAsStrings,
} from '../../helpers/helpers';

import i18n from '../../i18n';
import { logoProfileUrl } from '../../constants/general';

import '../../assets/stylesheets/ScheduleView.css';

class PositionSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: true
    };
  }

  handleExpandClick = () => {
    this.setState(prevState => ({ expandView: !prevState.expandView }));
  };

  displaySchedule = () => {
    const { expandView } = this.state;
    const {
      positionId,
      scheduleData,
      startOfSelectedWeek,
      onEmployeeSelect,
      includeWeekend
    } = this.props;
    const daysInSelectedWeek = generateDaysOfWeekAsStrings(startOfSelectedWeek, includeWeekend);

    const generatedSchedule = (
      <Collapse in={expandView} timeout="auto">
        <Grid container>
          <DateHeadings
            startOfSelectedWeek={startOfSelectedWeek}
            includeWeekend={includeWeekend}
          />
          {scheduleData.map(locationData => {
            const { locationId, locationName, scheduleBookings } = locationData;
            return (
              <React.Fragment key={`${positionId}-${locationId}`}>
                <Grid item xs={2} className="locationLabel">
                  {locationName}
                </Grid>

                {daysInSelectedWeek.map(day => {
                  const bookedEmployees = _.orderBy(
                    scheduleBookings[day],
                    'status',
                    'asc'
                  );
                  return (
                    <Grid
                      key={`${positionId}-${locationId}-${day}`}
                      item
                      xs={includeWeekend ? 1 : 2}
                      className={
                        includeWeekend ? 'customGridItem includeWeekend' : ''
                      }
                    >
                      {Object.values(bookedEmployees).map(employee => {
                        const {
                          employeeId,
                          employeeName,
                          profileImage,
                          isSelected,
                          status,
                          availabilityType
                        } = employee;
                        return (
                          <EmployeeChip
                            key={`${positionId}-${locationId}-${day}-${employeeId}`}
                            positionId={positionId}
                            locationId={locationId}
                            bookedDate={day}
                            employeeId={employeeId}
                            employeeName={employeeName}
                            profileImage={profileImage || logoProfileUrl}
                            isSelected={isSelected}
                            status={status}
                            onEmployeeSelect={onEmployeeSelect}
                            availabilityType={availabilityType}
                          />
                        );
                      })}
                    </Grid>
                  );
                })}

                <Grid item xs={12}>
                  <hr />
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
      </Collapse>
    );

    return generatedSchedule;
  };

  render() {
    const { expandView } = this.state;
    const { positionName } = this.props;

    return (
      <Paper id={positionName} className="blockContainer">
        <div className="blockHeader">
          <h2>{i18n.t(`positions:${positionName}`)}</h2>
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMoreIcon color="secondary" />
          </IconButton>
        </div>
        {this.displaySchedule()}
      </Paper>
    );
  }
}

PositionSchedule.propTypes = {
  positionId: PropTypes.number.isRequired,
  positionName: PropTypes.string.isRequired,
  startOfSelectedWeek: PropTypes.instanceOf(Date).isRequired,
  scheduleData: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEmployeeSelect: PropTypes.func.isRequired,
  includeWeekend: PropTypes.bool.isRequired
};

export default PositionSchedule;
